import { render, staticRenderFns } from "./SoftwareFinding.vue?vue&type=template&id=2d0d371f&"
import script from "./SoftwareFinding.vue?vue&type=script&lang=js&"
export * from "./SoftwareFinding.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports